export default {
  auth_request(state) {
    state.authStatus = 'loading';
  },
  auth_success(state, { token, user }) {
    state.authStatus = 'success';
    state.token = token;
    state.user = user;
  },
  auth_error(state) {
    state.authStatus = 'error';
  },
  logout(state) {
    state.authStatus = '';
    state.token = '';
    state.user = '';
    localStorage.clear();
  },
  GET_LIST_USER: (state, data) => {
    state.users = data;
  },
  GET_LIST_KOTAPROVINSI: (state, data) => {
    state.kotaProvinsi = data;
  },
};
